import type { ISaveSpecialDealParams, ISpecialDeal } from '@condo/domain';
import { omit } from 'lodash-es';
import { getClient } from './api-client';

export const fetchSpecialDeals = async (salesPackageId: number): Promise<ISpecialDeal[]> =>
    getClient('basecamp')
        .get('/special-deals', { params: { salesPackageId } })
        .then(({ data }) => data.specialDeals);

export const saveSpecialDeal = async (specialDeal: ISaveSpecialDealParams): Promise<ISpecialDeal> =>
    getClient('basecamp')
        .put('/special-deals', specialDeal)
        .then(({ data }) => data.specialDeal);

export const upsertAndProcessEstatesToSpecialDeal = async (params: {
    specialDealId: number;
    upsertedEstateIds?: number[];
    deletedEstateIds?: number[];
}): Promise<void> => getClient('basecamp').put(`/special-deals/${params.specialDealId}/estates`, omit(params, 'specialDealId'));
